const STORAGE_KEY = "flipacoin_guest";

const getGuestScore = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) return JSON.parse(stored);
    } catch (e) {
        // corrupted data
    }
    return {
        currentScore: 0,
        highScore: 0,
        currentStrikeType: "heads",
        highScoreStrikeType: "heads",
    };
};

const saveGuestScore = (score) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(score));
};

const guestFlipACoin = () => {
    const result = Math.random() < 0.5 ? "heads" : "tails";
    const score = getGuestScore();

    if (result === score.currentStrikeType) {
        score.currentScore += 1;
    } else {
        score.currentScore = 1;
        score.currentStrikeType = result;
    }

    if (score.currentScore > score.highScore) {
        score.highScore = score.currentScore;
        score.highScoreStrikeType = score.currentStrikeType;
    }

    saveGuestScore(score);

    return {
        data: {
            currentStrikeType: result,
            currentScore: score.currentScore,
        },
        score,
    };
};

export { getGuestScore, guestFlipACoin };
